import React, { useState } from 'react'
import { useTable, useGlobalFilter } from 'react-table'
import './table.css'
import { ArrowDownUp } from 'react-bootstrap-icons'
import { TextField, Box, Modal } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan, faEye } from '@fortawesome/free-solid-svg-icons'
import { useSelector } from 'react-redux'
import ApprovalMagin from './ApprovalMagin'
import { t } from 'i18next'
import { Formatter } from 'Utils/Formatter'
import { isCostExemptProduct, isDummyLitaProduct } from 'Utils/functions'
import InventoryModal from 'Components/InventoryModal'

function TableOrdenDeVenta({
  data,
  prodWithNoCost,
  columns,
  isProductPage,
  hideFooter,
  isInventory,
  hiddenColumns,
  changeSelectedStatus,
  selectAllProducts,
  setChangeQty,
  onDeleteProductCallback,
  setIsApproved,
  hasChangePriceApprove,
  interactionDisabled = false,
  interactionDisabledReason,
}) {
  const isCustomer = useSelector(state => state.login.isCustomer)

  const [modalApprovalVisible, setModalApprovalVisible] = useState(false)

  const [isOpenInventory, setIsOpenInventory] = useState(false)
  const [selectedProductId, setSelectedProductId] = useState(null)

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns,
      },
    },
    useGlobalFilter
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
  } = tableInstance

  const validateAllChecked = () => {
    const isAllChecked = data
      .filter(item => !item.isDisabled)
      .every((item, i) => item.isSelected)

    return isAllChecked
  }

  const handleQtyChange = (value, index, product) => {
    let newValue = value.target.value
    const qtyPending = Number(data[index].pendingQuantity)

    let newPendiente = qtyPending - newValue

    if (value.target.value === '') {
      const updatedData = {
        ...data[index],
        solicitud_despacho: newValue,
        qtyPending: Formatter.Money(newPendiente, {
          decimalPrecision: 2,
          ignoreDecimal: !data[index]?.allowFractionalQty,
        }).replace(/,/g, ''),
      }
      setChangeQty([
        ...data.slice(0, index),
        updatedData,
        ...data.slice(index + 1),
      ])
      return
    }

    const newProduct = sellOrderPostData?.Data?.SalesDocumentInfo?.Lines.find(
      p => p.ProductId === product.productId
    )

    if (!newProduct) return

    // Verifica si el producto permite cantidades fraccionarias
    const allowFractionalQty = newProduct.AllowFractionalQty

    // Actualiza la expresión regular para validar el valor
    const regex = allowFractionalQty ? /^\d*\.?\d{0,4}$/ : /^\d{0,6}$/

    if (!regex.test(newValue)) return

    if (!isNaN(newValue) || newValue === '') {
      if (newValue >= qtyPending) {
        newPendiente = 0
        newValue = qtyPending
      }
      const updatedData = {
        ...data[index],
        solicitud_despacho: newValue,
        qtyPending: Formatter.Money(newPendiente, {
          decimalPrecision: 2,
          ignoreDecimal: !data[index]?.allowFractionalQty,
        }).replace(/,/g, ''),
      }
      setChangeQty([
        ...data.slice(0, index),
        updatedData,
        ...data.slice(index + 1),
      ])
    }
  }

  const validateColumn = column => {
    if (existingReturns && !existingPendingQuantity) {
      return (
        column !== 'Solicitud despacho' &&
        column !== 'Acciones' &&
        column !== 'check'
      )
    } else if (!existingReturns && !existingPendingQuantity) {
      return (
        column !== 'Solicitud despacho' &&
        column !== 'Acciones' &&
        column !== 'check' &&
        column !== 'Devoluciones'
      )
    } else if (!existingReturns) {
      return column !== 'Devoluciones'
    }
    return true
  }

  const existingReturns = data.some(line => line.qtyReturned > 0)
  const existingPendingQuantity = data.some(line => line.pendingQuantity > 0)

  const { sellOrderPostData } = useSelector(state => state.sellOrder)

  const handleOpenInventory = product => {
    if (isDummyLitaProduct(product)) return

    setSelectedProductId(product.productId)
    setIsOpenInventory(true)
  }

  const handleCloseInventory = () => {
    setSelectedProductId(null)
    setIsOpenInventory(false)
  }

  return (
    <>
      <Modal open={modalApprovalVisible} data-testid="modal-approval-margin">
        <Box className="modal-box-message">
          <ApprovalMagin
            modalApprovalVisible={modalApprovalVisible}
            setModalApprovalVisible={setModalApprovalVisible}
            setIsApproved={setIsApproved}
          />
        </Box>
      </Modal>
      <div className="table-sell-order-topbar">
        <div className="table-sell-order-filter-options"></div>
      </div>
      <table
        className="table-sell-order-table-style"
        {...getTableProps()}
        data-testid="table-sales-order">
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers
                .filter(header => validateColumn(header.Header))
                .map((column, i) => (
                  <th
                    key={i}
                    {...column.getHeaderProps({
                      style: {
                        width: column.width,
                      },
                    })}>
                    {column.Header !== 'check' ? (
                      <div className="order-header-table-container">
                        <div className="order-header-text">
                          {column.render('Header')}
                        </div>
                        {column.arrowOrderEnabled ? (
                          <ArrowDownUp className="arrow-order-style" />
                        ) : null}
                      </div>
                    ) : (
                      <div className="table-order-check-style">
                        <input
                          type="checkbox"
                          onClick={event => {
                            selectAllProducts(event.target.checked)
                          }}
                          readOnly={true}
                          checked={!interactionDisabled && validateAllChecked()}
                          disabled={isCustomer || interactionDisabled}
                          data-testid="checkbox-select-all-products"
                        />
                      </div>
                    )}
                  </th>
                ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, index) => {
            prepareRow(row)
            const isRowDummyProduct = isDummyLitaProduct(row.original)
            return (
              <tr
                key={index}
                {...row.getRowProps({
                  style: {
                    borderBottom:
                      rows.length <= index + 1 ? '1px solid #E1E1E1' : 'none',
                    ...(isRowDummyProduct && {
                      backgroundColor: 'var(--error-background-color)',
                      border: '2px solid var(--error-color)',
                    }),
                  },
                })}>
                {row.cells
                  .filter(cell => validateColumn(cell.column.Header))

                  .map((cell, i) => (
                    <td
                      key={i}
                      {...cell.getCellProps({
                        style: {
                          width: cell.column.width,
                          padding: '21px 23px',
                          justifyContent: 'center',
                          color:
                            isRowDummyProduct ||
                            !cell.row.original.IsActive ||
                            prodWithNoCost?.some(
                              prod =>
                                prod.referencia === cell.row.original.referencia
                            )
                              ? 'red'
                              : 'inherit',
                        },
                      })}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}>
                        {' '}
                        {cell.column.Header === 'check' ? (
                          <div className="table-order-check-style">
                            <input
                              type="checkbox"
                              onClick={() => {
                                changeSelectedStatus(index)
                              }}
                              readOnly={true}
                              checked={cell.row.values.isSelected}
                              value={cell.row.values.isSelected}
                              disabled={
                                interactionDisabled ||
                                cell.row.original?.isDisabled
                              }
                            />
                          </div>
                        ) : cell.column.Header === 'Solicitud despacho' &&
                          data.length > 0 &&
                          cell.row.original?.pendingQuantity > 0 ? (
                          <TextField
                            value={data[index]?.solicitud_despacho || ''}
                            inputProps={{ style: { fontSize: 14 } }} // font size of input text
                            InputLabelProps={{ style: { fontSize: 14 } }} // font size of input label
                            disabled={
                              interactionDisabled ||
                              isDummyLitaProduct(cell.row.original) ||
                              (cell.row.original?.negativeMargen &&
                                !cell.row.original?.isApproved) ||
                              !cell.row.original.IsActive ||
                              (!cell.row.original.IsService &&
                                !isCostExemptProduct(cell.row.original) &&
                                cell.row.original.costo === 0)
                            }
                            onChange={value => {
                              handleQtyChange(value, index, cell.row.original)
                            }}
                          />
                        ) : cell.column.Header === 'Costo' &&
                          data.length > 0 ? (
                          data[index].costModifier ? (
                            <TextField
                              value={data[index].costo}
                              disabled={interactionDisabled}
                              inputProps={{ style: { fontSize: 14 } }} // font size of input text
                              InputLabelProps={{ style: { fontSize: 14 } }} // font size of input label
                              onChange={value => {
                                setChangeQty([
                                  ...data.slice(0, index),
                                  {
                                    ...data[index],
                                    costo: value.target.value,
                                  },
                                  ...data.slice(index + 1),
                                ])
                              }}
                            />
                          ) : (
                            <div className="order-table-text">
                              {'$'}
                              {cell.render('Cell')}
                            </div>
                          )
                        ) : cell.column.Header === 'Acciones' ? (
                          <div className="table-sell-order-inventory-actions">
                            {cell.row.original?.pendingQuantity > 0 ? (
                              <FontAwesomeIcon
                                className={`table-sell-order-trash-icon-size${
                                  isRowDummyProduct || interactionDisabled
                                    ? ' table-sell-order-trash-icon-disabled'
                                    : ''
                                }`}
                                icon={faTrashCan}
                                aria-disabled={
                                  isRowDummyProduct || interactionDisabled
                                }
                                title={
                                  interactionDisabled
                                    ? interactionDisabledReason
                                    : isRowDummyProduct
                                    ? t('DUMMY_LITA_T.CANCEL_DISABLED')
                                    : undefined
                                }
                                onClick={
                                  isRowDummyProduct || interactionDisabled
                                    ? undefined
                                    : () => {
                                        onDeleteProductCallback(
                                          cell.row.original
                                        )
                                      }
                                }
                              />
                            ) : null}
                          </div>
                        ) : cell.column.Header === 'Precio total' ? (
                          <div className="order-table-text">
                            {'$ ' +
                              Formatter.Money(cell.value, {
                                decimalPrecision: 2,
                                rounded: true,
                              })}
                          </div>
                        ) : cell.column.Header === 'Precio unitario' ? (
                          <div className="order-table-text">
                            {'$ ' + Formatter.Money(cell.value)}
                          </div>
                        ) : cell.column.Header === 'Referencia' ? (
                          <div className="order-table-text">
                            {cell.render('Cell')}
                          </div>
                        ) : (
                          <div className="order-table-text">
                            {cell.render('Cell')}
                          </div>
                        )}
                        {cell.column.Header === 'Cantidad' && (
                          <div className="table-sell-order-inventory-actions">
                            <FontAwesomeIcon
                              style={{ fontSize: '18px', marginLeft: 5 }}
                              onClick={
                                isRowDummyProduct
                                  ? undefined
                                  : () => {
                                      handleOpenInventory(cell.row.original)
                                    }
                              }
                              icon={faEye}
                              aria-disabled={isRowDummyProduct}
                              title={
                                isRowDummyProduct
                                  ? t('DUMMY_LITA_T.INVENTORY_DISABLED')
                                  : undefined
                              }
                              className={`table-sell-order-view-icon${
                                isRowDummyProduct
                                  ? ' table-sell-order-view-icon-disabled'
                                  : ''
                              }`}
                            />
                          </div>
                        )}
                      </div>
                    </td>
                  ))}
              </tr>
            )
          })}
        </tbody>
        {hideFooter ? null : (
          <tfoot
            className={isInventory ? 'stickyFooter' : null}
            style={{
              borderBottom: isProductPage && 'none',
              borderLeft: isProductPage && 'none',
              borderRight: isProductPage && 'none',
            }}>
            {footerGroups.map((group, i) => (
              <tr key={i} {...group.getFooterGroupProps()}>
                {group.headers.map((column, i) => (
                  <td
                    key={i}
                    style={{ border: isProductPage && 'none' }}
                    {...column.getFooterProps()}>
                    {column.render('Footer')}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot>
        )}
      </table>
      <InventoryModal
        isOpen={isOpenInventory}
        onClose={handleCloseInventory}
        productId={selectedProductId}
      />
    </>
  )
}

export default TableOrdenDeVenta
